import React from "react";
import CoursesPageClient from "@/components/admin/CoursesPageClient";

export default function CoursesPage() {
    return <CoursesPageClient initialCourses={[]} />;
}
